import type { OnboardingStep } from '@agentic-flow-studio/shared/components/onboarding/OnboardingChecklist';

export function onboardingSteps(orgId: string, workspaceId: string): OnboardingStep[] {
  const settings = `/org/${orgId}/workspace/${workspaceId}/settings`;

  return [
    {
      id: 'workspace-created',
      title: 'Workspace created',
      description: 'Your shared home is ready.',
      isComplete: () => true,
    },
    {
      id: 'name-workspace',
      title: 'Name your workspace',
      description: 'Make the space recognizably yours.',
      isComplete: (state) => !state.isAutoNamed,
      isVisible: (state) => state.isAdmin,
      action: { kind: 'rename', label: 'Name workspace' },
    },
    {
      id: 'connect-inbox',
      title: 'Connect your inbox',
      description: 'See real conversations in Triage.',
      isComplete: (state) => state.hasConnectedAccount,
      action: { kind: 'link', label: 'Connect inbox', to: `${settings}/accounts` },
    },
    {
      id: 'invite-teammate',
      title: 'Invite a teammate',
      description: 'Bring in the person who shares this inbox.',
      isComplete: (state) => state.hasTeammate,
      isVisible: (state) => state.isAdmin,
      action: { kind: 'link', label: 'Invite teammate', to: `${settings}/members` },
    },
  ];
}
